<template>
  <div>
    <!-- Services that are can be applied for -->
    <title-component :size="1">
      <translate>Apply for a new service</translate>
    </title-component>
    <table-component
      v-if="loaded"
      :content="getInactiveServices"
      :headings="service_inactive_headers"
      :item_keys="service_inactive_keys"
      :display_spec="serviceSpecs"
      class="services-table">
    </table-component>
    <!-- Services that are already applied for -->
    <title-component :size="1">
      <translate>Active services</translate>
    </title-component>
    <table-component
      v-if="loaded"
      :content="getActiveServices"
      :headings="service_active_headers"
      :item_keys="service_active_keys"
      :display_spec="serviceSpecs"
      class="services-table">
    </table-component>
  </div>
</template>
<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import TitleComponent from '@/components/layout/TitleComponent'
  import TableComponent from '@/components/layout/table/TableComponent'
  import { serviceSpecs } from '@/display_context/display_context'
  import { errorHandler, setContainedHeightMixin } from '@/mixins/mixins'

  export default {
    name: 'apply-for-service-view',
    mixins: [errorHandler, setContainedHeightMixin],
    data () {
      return {
        service_inactive_headers: ['Service', 'Description', 'Qualification', ''],
        service_inactive_keys: ['name', 'description', 'availableQualificationsStr', 'button'],
        service_active_headers: ['Service', 'Description', 'Qualification', 'Application date'],
        service_active_keys: ['name', 'description', 'appliedQualificationsStr', 'created'],
        serviceSpecs: serviceSpecs,
        loaded: false
      }
    },
    components: {
      TitleComponent,
      TableComponent
    },
    computed: {
      ...mapState({
        services: state => state.serviceModule.services
      }),
      ...mapGetters([
        'getActiveServices',
        'getInactiveServices'
      ])
    },
    methods: {
      ...mapActions([
        'getServices'
      ]),
      applyForService (row, params) {
        this.$router.push({ name: 'ApplicationView', params: { code: params.code } })
      },
      createButtons () {
        for (let service of this.services) {
          let btnClasses = service.active ? 'is-primary' : 'is-light'
          btnClasses += ' min-width is-pulled-right'
          let btnText = this.$gettext('Apply now')
          service.button = {
            clickHandler: this.applyForService,
            handlerParams: { code: service.code },
            text: btnText,
            customClasses: btnClasses
          }
        }
        this.loaded = true
      }
    },
    created () {
      this.getServices().then(() => {
        this.createButtons()
      }).catch((err) => {
        this.handleError(err)
      })
    }
  }
</script>
<style lang="sass" scoped>
  .services-table
    margin-top: 5rem
</style>
